import React, { useEffect, useState } from "react";
import "./rng.scss";
import { Modal, ProgressBar } from "react-bootstrap";
import {
    callCrashGameGraphQLQuery,
    callGraphQLQuery,
  } from "../../utils/axiosClient";
// import Loader from "../../../hooks/loader";

const RngList = () => {
  const [crashGameData, setCrashGameData] = useState([]);
  const [oddsGameData, setOddsGameData] = useState([]);
  const [combinedTableData, setCombinedTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [show7, setShow7] = useState(false);

  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [step, setStep] = useState("initial");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (step === "generating") {
      let prog = 0;
      const interval = setInterval(() => {
        prog += 2;
        setProgress(prog);
        if (prog >= 100) {
          clearInterval(interval);
          setTimeout(() => setStep("done"), 400);
        }
      }, 50);

      return () => clearInterval(interval); // Clean up
    }
  }, [step]);

  const handleGenerate = () => {
    setStep("reset"); // First, go to reset state (will hide progress bar)
    setProgress(0); // Immediately reset progress

    // Small delay to allow React to flush state before re-rendering progress bar
    setTimeout(() => {
      setStep("generating"); // Now start generating from 0
    }, 50);
  };

  const fetchOddsGameData = async () => {
    setLoading(true);
    const query = `
      query GetResolvedBets {
       betResolveds(orderBy: blockTimestamp, orderDirection: desc){
  won
  player
  payout
  amount
  odds
  transactionHash
  blockTimestamp
  random
}
      }
    `;

    try {
      const data = await callGraphQLQuery(query);

      setOddsGameData(data?.betResolveds);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCrashGameData = async () => {
    const query = `
    query PreviousRounds {
      previousRounds( orderBy: blockNumber, orderDirection: desc) {
        blockTimestamp
        transactionHash
        indexId
        rng
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const recentGames = data?.previousRounds || [];

      setCrashGameData(recentGames);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch graph chart data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCrashGameData();
    fetchOddsGameData();
  }, []);

  useEffect(() => {
    const processedCrashData = crashGameData.map((game) => ({
      blockTimestamp: game.blockTimestamp,
      transactionHash: game.transactionHash,
      source: "Crash Game",
      player: "",
      result: game.rng,
    }));

    const processedOddsData = oddsGameData.map((bet) => ({
      blockTimestamp: bet.blockTimestamp,
      transactionHash: bet.transactionHash,
      source: "Odds Game",
      player: bet.player,
      result: bet.random,
    }));
    const allGames = [...processedCrashData, ...processedOddsData];
    allGames.sort((a, b) => b.blockTimestamp - a.blockTimestamp);
    setCombinedTableData(allGames);
  }, [crashGameData, oddsGameData]);

  return (
    <>
    {/* {loading &&(<Loader/>)} */}
      <section className="mainbanner">
        <div className="custom-container">
          {/* <h1 className="bannerhead">
            Generate a Random Number with Luckify RNG
          </h1> */}
          <div className="innerbanner">
            {/* <div className="bannerleft">
              <h6 className="lefthead">Random Number Generator</h6>
              <div className="leftinner">
                <div
                  className={`slide resultmain ${
                    step === "initial" ? "active" : ""
                  }`}
                >
                  <p className="resultpara">Result will appear here</p>
                </div>
                <div
                  className={`slide generatingmain ${
                    step === "generating" || step === "reset" ? "active" : ""
                  }`}
                >
                  <h6 className="generatehead">Generating a Random Number</h6>
                  <p className="genratepara">
                    Waiting for the blockchain to generate a random number.
                  </p>

                  {/* Only show progress bar when actually generating */}
            {step === "generating" && (
              <div className="progress">
                <div
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                />
              </div>
            )}
            {/* </div>

                <div
                  className={`slide numbermain ${
                    step === "done" ? "active" : ""
                  }`}
                >
                  <h1 className="mainnumber">2451</h1>
                  <p className="resultpara">Result</p>
                </div>
              </div>
              <button onClick={handleShow7} className="bluebtn">
                {" "}
                {step === "generating"
                  ? "GENERATING..."
                  : "GENERATE A RANDOM NUMBER"}
              </button>
              <div className="lowermain">
                {step === "done" ? (
                  <div className="lowerinner">
                    <p className="leftpara">Generated at</p>
                    <h6 className="dashpara">04 May 2025 12:43</h6>
                  </div>
                ) : (
                  <div className="lowerinner">
                    <p className="leftpara">Generated at</p>
                    <h6 className="dashpara">--</h6>
                  </div>
                )}
                {step === "done" ? (
                  <div className="lowerinner">
                    <p className="leftpara">Hash</p>
                    <h6 className="dashpara">
                      <a href="" className="mainlink">
                        0xA1B...F12
                      </a>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1712_3225)">
                          <path
                            d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                            stroke="#B078FF"
                            stroke-width="1.04"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.5 1.5L6 6"
                            stroke="#B078FF"
                            stroke-width="1.04"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.5 1.5H10.5V4.5"
                            stroke="#B078FF"
                            stroke-width="1.04"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1712_3225">
                            <rect width="12" height="12" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </h6>
                  </div>
                ) : (
                  <div className="lowerinner">
                    <p className="leftpara">Hash</p>
                    <h6 className="dashpara">--</h6>
                  </div>
                )}
              </div>
            </div> */}

            <div className="maininnerlower">
              <div className="playtable">
                <h6 className="playhead">Latest Generated Random Numbers </h6>
                <div className="maintable">
                  <div className="innertable">
                    <table>
                      <thead>
                        <tr>
                          <th>Date & Time</th>
                          <th>Tx Hash</th>
                          <th>Source</th>
                          <th>By</th>
                          <th>Result</th>
                        </tr>
                      </thead>

                      <tbody>
                        {combinedTableData.map((row, index) => (
                          <tr key={`${row.transactionHash}-${index}`}>
                            <td>
                              <p className="datepara">
                                {new Date(
                                  row.blockTimestamp * 1000
                                ).toLocaleString()}
                              </p>
                            </td>
                            <td>
                              <div className="mainlink">
                                <a
                                  href={`https://bscscan.com/tx/${row.transactionHash}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {`${row.transactionHash.substring(
                                    0,
                                    6
                                  )}...${row.transactionHash.substring(
                                    row.transactionHash.length - 4
                                  )}`}
                                </a>
                                <a
                                  href={`https://bscscan.com/tx/${row.transactionHash}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M11.1667 1.5L6.66675 6"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.16675 1.5H11.1667V4.5"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </td>
                            <td>
                              <div className="mainlink">
                                <p>{row.source}</p>
                              </div>
                            </td>
                            <td>
                              <div className="mainlink">
                                <p>
                                  {row.player
                                    ? `${row.player.substring(
                                        0,
                                        6
                                      )}...${row.player.substring(
                                        row.player.length - 4
                                      )}`
                                    : "N/A"}
                                </p>
                                <a
                                  href={`https://bscscan.com/address/${row.player}`}
                                  className="innerlink"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13"
                                    height="12"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M11.1667 1.5L6.66675 6"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.16675 1.5H11.1667V4.5"
                                      stroke="#3E3F43"
                                      stroke-width="1.04"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </td>
                            <td>
                              <p className="bluepara">{row.result}</p>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="mainboxes d-none">
                  {combinedTableData.map((row, index) => (
                    <div
                      className="mainbox"
                      key={`${row.transactionHash}-${index}`}
                    >
                      <div className="innerbox">
                        <p className="boxpara">Date & Time</p>
                        <h6 className="boxhead">
                          {new Date(row.blockTimestamp * 1000).toLocaleString()}
                        </h6>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Tx Hash</p>
                        <div className="mainlink">
                          <a
                            href={`https://bscscan.com/tx/${row.transactionHash}`}
                            className="innerlink"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {`${row.transactionHash.substring(
                              0,
                              6
                            )}...${row.transactionHash.substring(
                              row.transactionHash.length - 4
                            )}`}
                          </a>
                          <a
                            href={`https://bscscan.com/tx/${row.transactionHash}`}
                            className="innerlink"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="12"
                              viewBox="0 0 13 12"
                              fill="none"
                            >
                              <path
                                d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11.1667 1.5L6.66675 6"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.16675 1.5H11.1667V4.5"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Source</p>
                        <div className="mainlink">{row.source}</div>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">By</p>
                        <div className="mainlink">
                          {row.player
                            ? `${row.player.substring(
                                0,
                                6
                              )}...${row.player.substring(
                                row.player.length - 4
                              )}`
                            : "N/A"}
                          <a
                            href={`https://bscscan.com/address/${row.player}`}
                            className="innerlink"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="12"
                              viewBox="0 0 13 12"
                              fill="none"
                            >
                              <path
                                d="M11.1667 6.5V9.5C11.1667 9.76522 11.0614 10.0196 10.8739 10.2071C10.6863 10.3946 10.432 10.5 10.1667 10.5H3.16675C2.90153 10.5 2.64718 10.3946 2.45964 10.2071C2.2721 10.0196 2.16675 9.76522 2.16675 9.5V2.5C2.16675 2.23478 2.2721 1.98043 2.45964 1.79289C2.64718 1.60536 2.90153 1.5 3.16675 1.5H6.16675"
                                stroke="#3E3F43"
                                strokeWidth="1.04" // Corrected: strokeWidth
                                strokeLinecap="round" // Corrected: strokeLinecap
                                strokeLinejoin="round" // Corrected: strokeLinejoin
                              />
                              <path
                                d="M11.1667 1.5L6.66675 6"
                                stroke="#3E3F43"
                                strokeWidth="1.04"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.16675 1.5H11.1667V4.5"
                                stroke="#3E3F43"
                                strokeWidth="1.04"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                      <div className="innerbox">
                        <p className="boxpara">Result</p>
                        <h6 className="bluepara">{row.result}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Modal className="editmodal" show={show7} onHide={handleClose7} centered>
        <Modal.Header closeButton>
          <Modal.Title>sign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
              >
                <path
                  d="M26 47.6667C37.9662 47.6667 47.6667 37.9662 47.6667 26C47.6667 14.0338 37.9662 4.33334 26 4.33334C14.0339 4.33334 4.33337 14.0338 4.33337 26C4.33337 37.9662 14.0339 47.6667 26 47.6667Z"
                  stroke="#B078FF"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 17.3333V26"
                  stroke="#B078FF"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 34.6667H26.0217"
                  stroke="#B078FF"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>You're about to sign a transaction authorization.</h6>
          </div>
          <p className="mainparamodal">
            This signature allows us to Generate the Random Number
          </p>

          <div className="bottom-btns">
            <button onClick={handleClose7} className="closebtn">
              Close
            </button>
            <button
              onClick={() => {
                handleClose7();
                handleGenerate();
              }}
              className="depositbtn"
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default RngList;
